import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const CopyIcon = ({ textToCopy }: { textToCopy: string }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(textToCopy);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  return (
    <OverlayTrigger
      placement="top"
      delay={{ show: 0, hide: 100 }} // Hiển thị ngay lập tức
      overlay={
        <Tooltip id={`tooltip-${textToCopy}`}>
          {copied ? "Copied!" : "Copy"}
        </Tooltip>
      }
    >
      <i
        role="button"
        style={{ fontSize: "12px", cursor: "pointer" }}
        className={`bi bi-${copied ? "check" : "copy"} text-muted`}
        onClick={handleCopy}
      ></i>
    </OverlayTrigger>
  );
};

export default CopyIcon;
